import { render, staticRenderFns } from "./SalesPromoSupplierGroup.vue?vue&type=template&id=1a962a64&"
import script from "./SalesPromoSupplierGroup.vue?vue&type=script&lang=js&"
export * from "./SalesPromoSupplierGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports